export function isObject(x: unknown): x is Record<string, unknown> {
  return typeof x === 'object' && x !== null;
}

//the API sends null for an absent value; the client models use undefined (httpService applies this to every answer)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function nullsToUndefined(obj: any): any {
  if (obj === null || obj === undefined) {
    return undefined;
  }

  if (obj.constructor.name === 'Object' || obj.constructor.name === 'Array') {
    for (const key in obj) {
      obj[key] = nullsToUndefined(obj[key]);
    }
  }

  return obj;
}
